module.exports = __webpack_public_path__ + "static/media/CloudCertificate.a9a98b23.png";